import { useIntercomStore } from '@/stores/intercom';
import { useTrackingStore } from '@/stores/tracking';

const GALLERY_TYPE_NAMES = {
  CAMPAIGNS: 'Campaigns',
  LIBRARY: 'Library',
  INSTAGRAM: 'Instagram',
  INSTAGRAM_STORY: 'Instagram_Story',
  TIKTOK: 'TikTok',
  PINTEREST: 'Pinterest',
  FACEBOOK: 'Facebook',
  TWITTER: 'X',
  YOUTUBE: 'YouTube',
  LINKEDIN: 'LinkedIn',
  SNAPCHAT: 'Snapchat',
  THREADS: 'Threads',
};

// parent component name: source
const GALLERY_ADDITION_SOURCES = {
  CampaignDetails: 'campaign detail page',
  Galleries: 'board list page',
  GalleriesControls: 'board list page',
  MultiSelectTopBar: 'multi select',
  MediaActionButtons: 'media popup',
};

const EVENT_NAMES = {
  BOARDS_ADD_BOARD_CLICKED: 'Boards Add Board Clicked',
  BOARDS_ADD_MEDIA_CLICKED: 'Boards Add Media Clicked',
  MULTISELECT_ACTION_CLICKED: 'Multi Select Action Clicked',
};

export function trackBoardsAddBoardClicked(galleryType, componentName) {
  const trackingStore = useTrackingStore();
  trackingStore.track(EVENT_NAMES.BOARDS_ADD_BOARD_CLICKED, {
    galleryType: GALLERY_TYPE_NAMES[galleryType],
    clickFrom: GALLERY_ADDITION_SOURCES[componentName],
    fromMultiSelectBar: componentName === 'MultiSelectTopBar',
  });
}

export function trackBoardsAddMediaClicked(galleryType) {
  const trackingStore = useTrackingStore();
  trackingStore.track(EVENT_NAMES.BOARDS_ADD_MEDIA_CLICKED, {
    galleryType: GALLERY_TYPE_NAMES[galleryType],
  });
}

export function trackMultiSelectActionClicked(buttonLabel, totalMedia) {
  const trackingStore = useTrackingStore();
  trackingStore.track(EVENT_NAMES.MULTISELECT_ACTION_CLICKED, {
    buttonLabel,
    totalMedia,
  });
}

export function trackBoardMediaAdded(properties) {
  const event = 'Board Media Added';
  const trackingStore = useTrackingStore();
  const intercomStore = useIntercomStore();
  trackingStore.track(event, properties);
  intercomStore.trackEvent(event, properties);
}
